import { useEffect, useState } from "react";

import { CodeBook } from "@king-ict/eupisi-ui/models";

import { useAuth } from "./useAuth";
import { Role } from "../../models";
import { ClaimType } from "../../models/User";
import { useGetCountiesQuery } from "../../queries/codeBookQuery";

interface IProps {
  returnAllCounties?: boolean;
}
/**
 * Provides an array of CodeBook items based on the user's
 * role. CAS and Helpdesk get all items. County users get only
 * items for which they have a location. Institution users get
 * an empty array.
 * @returns Items for Global and County users or an empty array
 * for Institution users.
 */
export const useAuthCounties = (props?: IProps): CodeBook[] => {
  const { returnAllCounties } = props || {};

  const auth = useAuth();
  const { data: counties, isLoading } = useGetCountiesQuery();
  const [authCounties, setAuthCounties] = useState<CodeBook[]>([]);

  useEffect(() => {
    if (
      ([Role.CAS, Role.Helpdesk].includes(auth.currentRole?.role ?? 0) ||
        returnAllCounties) &&
      counties
    ) {
      setAuthCounties(counties);
    } else if (
      (auth?.currentRole?.role === Role.CountyAdministrator ||
        auth?.currentRole?.role === Role.CountyLeader ||
        auth?.currentRole?.role === Role.CountyCommittee ||
        auth?.currentRole?.role === Role.Founder) &&
      auth?.currentRole?.claimType === ClaimType.County &&
      counties
    ) {
      setAuthCounties(
        counties?.filter(
          (v) =>
            auth?.currentRole?.locations?.find((l) => v.id === l) !== undefined
        )
      );
    } else {
      setAuthCounties([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [counties, isLoading]);

  return authCounties;
};

export default useAuthCounties;
